import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toggleLoginModal } from '@department-of-veterans-affairs/platform-site-wide/actions';
import {
  VaAlertSignIn,
  VaButton,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
// eslint-disable-next-line import/no-named-default
import { default as recordEventFn } from '~/platform/monitoring/record-event';

export const headingPrefix = 'Sign in with a verified account';

/**
 * Alert to show a user that is not logged in.
 * @property {number} headerLevel the heading level
 * @property {*} recordEvent the function to record the event
 */
const UnauthenticatedAlert = ({ headerLevel, recordEvent = recordEventFn }) => {
  useEffect(() => {
    recordEvent({
      event: 'nav-alert-box-load',
      action: 'load',
      'alert-box-headline': headingPrefix,
      'alert-box-status': 'info',
    });
  }, [recordEvent]);

  const dispatch = useDispatch();
  const handleSignIn = () => {
    dispatch(toggleLoginModal(true, 'mhv-signin-cta', true));
  };

  return (
    <div data-testid="mhv-unauthenticated-alert">
      <VaAlertSignIn
        variant="signInRequired"
        headingLevel={headerLevel}
        visible
      >
        <span slot="SignInButton">
          <VaButton
            onClick={handleSignIn}
            text="Sign in or create an account"
          />
        </span>
      </VaAlertSignIn>
    </div>
  );
};

UnauthenticatedAlert.propTypes = {
  headerLevel: PropTypes.number,
  recordEvent: PropTypes.func,
};

export default UnauthenticatedAlert;
